// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__G2yq2","cell":"ColumnAccessor_cell__1IGKB","firstCellAccent":"ColumnAccessor_firstCellAccent__W3Avv"};